import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { claimStatusTone } from '@eis/core';
import { StatusChip } from '@eis/patterns';

/**
 * A claim's status (SDD-018 §9): the label from this module's `status.<name>` keys, the tone from
 * claimservice.default-statuses.json's `token` — a status a tenant added in the suite shows its own
 * name, drawn neutral.
 */
export function ClaimStatusChip({ status }: { readonly status: string }): ReactNode {
  const { t } = useTranslation('claims');
  return (
    <StatusChip
      status={status}
      tone={claimStatusTone(status)}
      label={t(`status.${status}` as never, { defaultValue: status })}
    />
  );
}
